/**
 * Experiments created on Petri should be listed here.
 *
 * #### Scopes
 *
 * Any new created specs should be conducted via centralized conduction.
 *
 * This means that they should be created with the following scopes:
 *
 * |            | Scope                                              |
 * | :-         | :-                                                 |
 * | Backoffice | `bm-apps-14bcded7-0066-7c35-14d7-466cb3f09103`     |
 * | Viewer     | `viewer-apps-14bcded7-0066-7c35-14d7-466cb3f09103` |
 */
export const EXPERIMENTS = {
    USE_MEDIA: 'specs.wixBlog.useMedia',
    USE_WARMUP_STATE_IN_FEED: 'specs.wixBlog.UseWarmupStateInFeed',
    USE_WARMUP_STATE_IN_POST_LIST: 'specs.wixBlog.UseWarmupStateInPostList',
    IS_MA_MODAL_ENABLED: 'specs.wixBlog.isMAModalEnabled',
    /**
     * Wix Employees: https://bo.wix.com/petri/experiments/2559551
     *
     * Uses BoB Post Page
     *
     * Adds the following CSS classes that should be removed when merging the experiment:
     * - `post-page--split`
     **/
    SPLIT_POST_PAGE: 'specs.wixBlog.SplitPostPage',
    /**
     * https://bo.wix.com/petri/experiments/2493470
     *
     * Install Blocks Post Page on Studio
     */
    BLOCKS_POST_PAGE_STUDIO: 'specs.wixBlog.BlocksPostPageOnStudio',
    /**
     * https://bo.wix.com/petri/experiments/2127880
     * - Fix for the Blog app pages are missing from site pages and menu in the editor.
     **/
    MAYBE_INSTALL_BLOG_PAGES: 'specs.wixBlog.MaybeInstallBlogPages',
    /**
     * https://bo.wix.com/petri/experiments/2184189
     * - Try to not install Search when installing Blog to see if it fixes the issue of Blog stuck installation at 4th step.
     **/
    DONT_INSTALL_SEARCH: 'specs.wixBlog.DontInstallSearch',
    /**
     * https://bo.wix.com/petri/experiments/2172660
     * - Switches to using WSR Toast component for displaying messages.
     **/
    USE_WSR_TOAST: 'specs.wixBlog.UseToast',
    /**
     * https://bo.wix.com/petri/experiments/2200181
     * - Remove handleAction from Blog Editor Script.
     **/
    REMOVE_HANDLE_ACTION: 'specs.wixBlog.RemoveHandleAction',
    /**
     * https://bo.wix.com/petri/experiments/2232767
     * - Adding Ai Img Generator btn to add panel items.
     **/
    AI_IMG_GENERATOR: 'specs.wixBlog.AiImgGenerator',
    /**
     * https://bo.wix.com/petri/experiments/2148532
     * - Enables "CSS per Breakpoint" compatibility.
     */
    CSS_PER_BREAKPOINT: 'specs.wixBlog.cssPerBp',
    /**
     * https://bo.wix.com/petri/experiments/2254004
     * - Enables Analytics in BM Blog Overview
     */
    BM_ANALYTICS: 'specs.wixBlog.BMAnalytics',
    /**
     * https://bo.wix.com/petri/experiments/2258243
     * - Fix Members Area Handle Action. More info here: https://jira.wixpress.com/browse/PING-3175 https://github.com/wix-private/pricing-plans/commit/3391f6dda47859f34d2d65c8c61d205d058fc21e
     */
    FIX_MEMBERS_AREA_HANDLE_ACTION: 'specs.wixBlog.FixMembersAreaHandleAction',
    /**
     * https://bo.wix.com/petri/experiments/2267228
     * - Provide user a modal to retry installation or delete Blog application on stuck installation.
     */
    INSTALLATION_FIXER: 'specs.wixBlog.InstallationFixer',
    /**
     * https://bo.wix.com/petri/experiments/2358683
     * - Adding Ai Text Generator btn to create/edit post page with new ai-popover flow.
     **/
    AI_POST_TITLE_GENERATOR: 'specs.wixBlog.AiPostTitleGenerator',
    /**
     * https://bo.wix.com/petri/experiments/2482681
     * - Ai Text Generator always displays.
     * - Use https://bo.wix.com/prompts-manager bmBlogPost_1.2
     **/
    AI_POST_TITLE_GENERATOR_V2: 'specs.wixBlog.AiPostTitleGeneratorV2',
    /**
     * https://bo.wix.com/petri/experiments/2375913
     * - Enable platform API for post page data
     **/
    IS_PLATFROM_API_FOR_POST_PAGE_ENABLED: 'specs.wixBlog.isPlatformApiForPostPageEnabled',
    /**
     * https://bo.wix.com/petri/experiments/2430724
     * - Toggles `rceNext` flag for Ricos Editor in BM
     */
    USE_RCE_NEXT: 'specs.wixBlog.UseRceNext',
    /**
     * https://bo.wix.com/petri/experiments/2430980
     * - Same idea as {@link EXPERIMENTS.USE_RCE_NEXT}, except for OOI widgets
     */
    USE_RCE_NEXT_OOI: 'specs.wixBlog.UseRceNextOOI',
    /**
     * https://bo.wix.com/petri/experiments/2434693
     * - Swaps the API used to platformized when retrieving post content
     */
    USE_RICH_CONTENT: 'specs.wixBlog.UseRichContent',
    /**
     * https://bo.wix.com/petri/experiments/2438127
     * - Blog Live Site Editor Deprecation
     */
    LIVE_SITE_EDITOR_DEPRECATION: 'specs.wixBlog.LiveSiteEditorDeprication',
    /**
     * https://bo.wix.com/petri/experiments/2457644
     * - Pin Post to Feed
     */
    PIN_POST_TO_FEED: 'specs.wixBlog.PinPost',
    /**
     * https://bo.wix.com/petri/experiments/1924842
     * - Fetch inner routes for TPA dynamic pages and cache it in state to support dynamicPagesComboBox for TPA's
     */
    FETCH_AND_CACHE_TPA_INNER_ROUTES: 'se_fetchAndCacheTPAInnerRoutes',
    /**
     * https://bo.wix.com/petri/experiments/2488697
     * Blog Ai popover title generator use prompt manager version for testing
     */
    AI_POST_TITLE_PROMPT_TESTING: 'specs.wixBlog.AiPostTitlePromptTesting',
    /**
     * https://bo.wix.com/petri/experiments/2521350
     * - Allow trailing slash in Post Composer SEO panel
     */
    ALLOW_SLUG_TRAILING_SLASH: 'specs.wixBlog.AllowSlugTrailingSlash',
};
//# sourceMappingURL=experiments.js.map